import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-error-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="error-banner" role="alert">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <span>{{ message() }}</span>
    </div>
  `,
  // Self-contained: the PrimeFlex-style utility classes used elsewhere in this repo
  // are not defined anywhere, so they cannot be relied on here.
  styles: `
    .error-banner {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.625rem 0.875rem;
      border: 1px solid var(--error-border);
      border-radius: 6px;
      background: var(--error-surface);
      color: var(--error-text);
      font-size: 0.875rem;
    }

    i {
      font-size: 1rem;
    }
  `,
})
export class ErrorBannerComponent {
  readonly message = input.required<string>();
}
